
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Jeder träumt jede Nacht. Auch jene, die sich nicht daran erinnern können. In ihrem Buch «Why We Dream» zitiert die amerikanische Wissenschaftsjournalistin Alice Robb zahlreiche Studien aus der modernen Traumforschung, die zeigen: Das nächtliche Kopfkino ist ein gnadenloser Spiegel unseres realen Lebens. In Träumen offenbaren sich Gefühle und Gedanken, die der wache Kopf nur erahnen kann und oft lieber ignoriert. Aber wozu das Ganze wirklich gut ist, darüber kann die Forschung bisher nur mutmassen. Einige Wissenschaftler gehen davon aus, dass wir träumen, um heikle oder gar gefährliche Situationen erst einmal ganz ohne Risiko üben zu können. Andere denken, `}<M mdxType="M">{`dass Träume vor allem eine Filterfunktion haben, da sie wichtige Informationen von belanglosen trennen.`}</M></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;